import React, { useMemo } from 'react';

import StatCard from '../../common/StatCard/StatCard';
import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';
import { percentFormatter } from '../../../utils/formatters';
import { MemoryIcon } from '../../common/icons/MemoryIcon';
import Icon from '../../common/icons/Icon';
import COLORS from '../../../constants/colors.constants';
import { formatUnitRatioForMemory } from '../../../utils/prometheus_utils';

const getRequestedMemoryQuery = () => {
  return 'sum(wallaroo_kube_pod_resource_requests{resource="memory"})';
}

const getTotalMemoryQuery = () => {
  return 'sum(kube_node_status_capacity{resource="memory"})';
}

const MemoryIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={MemoryIcon} size={24} useTailwindSizing />
}

export const useTotalMemory = () => {
  const query = useMemo(() => {
    return getTotalMemoryQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedMemory = () => {
  const query = useMemo(() => {
    return getRequestedMemoryQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const ContextualMemoryCard = () => {
  const requestedResponse = useRequestedMemory()
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const totalResponse = useTotalMemory()
  const totalData = totalResponse?.chartData;
  const totalValue = totalData?.length ? totalData[1] : 0;

  const subVal = formatUnitRatioForMemory(requestedValue, totalValue);
  const subtitle = `Requested ${subVal} Allocated`;

  const content = totalValue ? percentFormatter.format(requestedValue / totalValue) : 0;

  const isLoading = requestedResponse?.isLoading || totalResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={MemoryIconComponent}
      header="Total Memory Currently Requested"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualMemoryCard;
